export function winTopPostMessage(data: any, origin = '*') {
  try {
    if (window.top && window.top.postMessage && window.top !== window) {
      window.top.postMessage(data, origin);
    }
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
  }
}
